import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface TaxMutexDialogProps {
  open: boolean;
  onOpenChange: (next: boolean) => void;
  /** Pre-built message; the caller knows which side won the conflict. */
  message: string;
}

/**
 * Surfaces the per-line ↔ invoice-level tax conflict. The wire's
 * `TaxConfig` is a single mode (`on_total` / `per_item` / etc), so
 * the two affordances can't both carry a rate. Rather than silently
 * overwriting whichever side was set first, we block and tell the
 * user what to do.
 */
export function TaxMutexDialog({ open, onOpenChange, message }: TaxMutexDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="size-4 text-amber-500" />
            Can't combine tax modes
          </DialogTitle>
          <DialogDescription>{message}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>OK</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
